module.exports = __webpack_public_path__ + "img/skyFrame.20c31b2c.png";